import { useSettingsReturn } from '~/composables/useSettingsReturn'
import { clearHeldScans } from '~/utils/heldScans'
import { MOVE_FORKS, leftSettingsElsewhere, nextReturn } from '~/utils/settingsReturn'

/**
 * Remembers which screen Settings was opened from, so its back arrow returns
 * there (utils/settingsReturn.ts).
 *
 * Move Pallets keeps its forks for that return (`MOVE_FORKS`, written as it
 * is left for Settings). If Settings is left for anywhere else, the forks are
 * dropped: kept any longer they would reappear, stale, the next time the
 * screen happened to be opened.
 */
export default defineNuxtPlugin(() => {
  const returnTo = useSettingsReturn()
  useRouter().beforeEach((to, from) => {
    if (leftSettingsElsewhere(returnTo.value, to, from)) clearHeldScans(MOVE_FORKS)
    returnTo.value = nextReturn(returnTo.value, to, from)
  })
})
